import React, { useEffect, useState } from "react";
import { images } from "../../config/images";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { Box, Grid } from "@mui/material";
import "../Gallery/Gallery.css";
import Aos from "aos";
import { gallery } from "../../config/services";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

const CustomPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    borderColor: "var(--accent-color)",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: "30px",
  },
  "& .Mui-selected": {
    borderColor: "var(--accent-color)",
    backgroundColor: "var(--accent-color) !important",
    color: "var(--white)",
  },
}));

const Gallery = ({ settingAPIData, headerAPIData }) => {
  const [galleryAPIData, setGallaryAPIData] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    Aos.init({ duration: 2400 });
  }, []);

  useEffect(() => {
    handlegallery();
  }, [currentPage]);

  const handlegallery = async () => {
    try {
      setIsLoading(true);
      const resp = await gallery(currentPage, perPage);
      if (resp.data.code === 200 || resp.data.code === 201) {
        setIsLoading(false);
        setGallaryAPIData(resp.data.responseBody);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching gallery data:", error);
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    { label: "Gallery", url: "/gallery" },
  ];

  return (
    <>
      <div>
        <div className="about-us-container">
          <div className="molecule left">
            <img
              src={images.leftSpirrel}
              alt="Left Molecule"
              className="left-spinner"
            />
          </div>
          <div className="about-text">
            <h1>Gallery</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img
              src={images.rightSpirrel}
              alt="Right Molecule"
              className="right-spinner"
            />
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="pt-5 pb-5 grid-section">
          <div className="common-sec">
            <Grid container spacing={5}>
              {isLoading ? (
                // Shimmer effect placeholders
                [...Array(6)].map((_, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                    <Box className="gallery-box shimmer-placeholder">
                   
                      <div
                        style={{
                          height: "260px",
                          background:
                            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                        }}
                      ></div>
                      <div className="p-3">
                        <div
                          className="shimmer-line"
                          style={{
                            height: "16px",
                            width: "30%",
                            marginBottom: "8px",
                            backgroundColor: "#e0e0e0",
                          }}
                        ></div>
                        <div
                          className="shimmer-line"
                          style={{
                            height: "16px",
                            width: "80%",
                            backgroundColor: "#e0e0e0",
                            marginBottom: "20px",
                          }}
                        ></div>
                      </div>
                    </Box>
                  </Grid>
                ))
              ) : galleryAPIData && galleryAPIData?.data?.length > 0 ? (
                galleryAPIData?.data?.map((data, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={data?.id ?? index}>
                    <Box
                      className="gallery-box"
                      onClick={() => {
                        navigate(`/gallery/${slugify(data?.name)}`, {
                          state: { name: data?.name, galleryId: data?.id },
                        });
                      }}
                    >
                      <div className="gallery-card-image-wrap">
                        <img
                          src={data?.image}
                          alt={data?.name || `Gallery ${index + 1}`}
                        />
                      </div>
                      <div className="gallery-card-body gallery-title">
                        <h6 className="gallery-card-title">{data?.name}</h6>
                      </div>
                    </Box>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <div className="gallery-empty-state" role="status" aria-live="polite">
                    <div className="gallery-empty-state-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <polyline points="21 15 16 10 5 21" />
                      </svg>
                    </div>
                    <h3>No gallery items yet</h3>
                    <p>There are no photos or events in the gallery at the moment. Check back later for updates.</p>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
          {galleryAPIData?.total > 0 && galleryAPIData?.data?.length > 0 && (
            <div className="gallery-pagination-wrap">
              <Stack spacing={2}>
                <CustomPagination
                  count={Math.ceil(
                    galleryAPIData.total / (galleryAPIData.per_page || perPage)
                  )}
                  page={currentPage}
                  onChange={handlePageChange}
                  siblingCount={1}
                  boundaryCount={2}
                />
              </Stack>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Gallery;
